export const muiConfig = {
    typography: {
        fontFamily: 'Georama, sans-serif',
    }
}